module.exports = "/assets/data/6bfb6acfa061b20e78d24a599647adca-DA11.data.json";